import { z } from "zod";

/**
 * The subscription page's tab ids, and the schema that validates the `?tab=`
 * deep link on both the settings and dashboard subscription routes.
 *
 * A zod enum rather than the hand-written `typeof tab === "string" && …includes()`
 * guard the two routes used to carry: every other `?tab=` surface in the app
 * validates with zod and `.catch(undefined)`, and two spellings of the same
 * check is how they drift.
 */
export const subTab = z.enum([
	"overview",
	"usage",
	"billing",
	"team",
	"addons",
]);

export type SubTab = z.infer<typeof subTab>;
